import * as tslib_1 from "tslib";
import RibbonPlugin from 'owa-editor-ribbonplugin/lib/plugin/RibbonPlugin';
import { getUserConfiguration } from 'owa-session-store';
import * as React from 'react';
import { ReactEditor } from 'owa-editor';
import { Ribbon } from 'owa-editor-ribbonplugin';
import { observer } from 'mobx-react';
var styles = require('./OptionsEditor.scss');
var OptionsEditor = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsEditor, _super);
    function OptionsEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.ribbonPlugin = new RibbonPlugin(_this.props.ribbonViewState);
        return _this;
    }
    OptionsEditor.prototype.componentDidMount = function () {
        this.props.initialize();
    };
    OptionsEditor.prototype.render = function () {
        var isRtl = this.props.isRtl || getUserConfiguration().SessionSettings.IsUserCultureRightToLeft;
        var watermark = this.props.watermark || '';
        return (React.createElement("div", { className: styles.editorContainer },
            React.createElement(Ribbon, { key: "ribbon", ribbonPlugin: this.ribbonPlugin, viewState: this.props.ribbonViewState, className: styles.ribbon }),
            React.createElement(ReactEditor, { key: "editor", watermark: watermark, isRtl: isRtl, viewState: this.props.editorViewState, plugins: this.plugins, classNames: styles.editor, updateOnKeyPress: true })));
    };
    Object.defineProperty(OptionsEditor.prototype, "plugins", {
        get: function () {
            // VSO 14829 - Use a common collection of plugins
            return [this.ribbonPlugin];
        },
        enumerable: true,
        configurable: true
    });
    OptionsEditor = tslib_1.__decorate([
        observer
    ], OptionsEditor);
    return OptionsEditor;
}(React.Component));
export default OptionsEditor;
//# sourceMappingURL=OptionsEditor.js.map